export default "__VITE_ASSET__glIXvRCU__"